/* ============================================================
   TENUTA GRIECI · tg-funnel.js            20/08/2026
   Due interventi sul percorso d'acquisto. Nessuno tocca theme.js
   né tg-upgrades.js: questo file si innesta prima e li pre-empta.

   Il criterio, dopo la revisione di Peppe: si toglie ATTRITO, non
   si aggiunge PRESSIONE. Tutto ciò che agisce DOPO che il cliente
   ha deciso è lecito; tutto ciò che lo sollecita PRIMA no — non su
   una scena che si guarda come un film.

   1) LOADER BREVE
      theme.js apre il loader con MIN=2700 e lo chiude su window.load
      (che aspetta anche l'mp4 dell'hero), poi 1.15s di dissolvenza:
      primo contenuto a ~3.9s nel caso migliore. Qui il loader dura
      1.1s su timer puro, si salta al primo tocco, e theme.js viene
      INIETTATO alla fine invece che caricato staticamente. theme.js
      trova .loader già rimosso, entra nel ramo `if(!el) onExit()` e
      costruisce la scena subito: la coreografia GSAP parte a schermo
      visibile, non sotto il velo.

   2) AGGIUNGI → CHECKOUT DIRETTO
      Con un articolo solo lo sheet chiedeva "checkout / carrello /
      continua a esplorare": una domanda con una risposta sola, perché
      a catalogo c'è una bottiglia. Intercettiamo il submit in fase di
      CAPTURE, prima del listener di tg-upgrades, e andiamo al checkout.

   RIMOSSO — barra d'acquisto fissa sulla home (.tg-homebar).
      Costruita il 20/08 e tolta lo stesso giorno: una pillola dorata
      fissa che segue lo scroll per dodici pannelli è un dispositivo da
      e-commerce di massa, incompatibile con una scena che si guarda.
      L'occasione d'acquisto resta dove è narrativamente sua: l'hero,
      il pannello edizione (data-buy), il blocco Gift, la sezione
      #purchase in fondo. Le regole .tg-homebar* in tg-fixes.css sono
      rimaste ma non agganciano più nulla: da togliere alla prossima
      modifica di quel file.
   ============================================================ */
(function(){
  'use strict';

  var CFG={};
  try{CFG=JSON.parse(document.getElementById('tg-routes').textContent)||{};}catch(e){CFG={};}
  var ROOT=(CFG.root||'/').replace(/\/$/,'');

  /* ---------- 1 · LOADER BREVE + iniezione di theme.js ---------- */
  (function fastLoader(){
    var me=document.currentScript;
    var SRC=me&&me.getAttribute('data-theme-src');
    var injected=false;
    function injectTheme(){
      if(injected||!SRC)return; injected=true;
      var s=document.createElement('script');
      s.src=SRC;
      (document.body||document.documentElement).appendChild(s);
    }
    if(!SRC)return;                       /* senza sorgente non tocchiamo niente */

    var el=document.querySelector('.loader');
    /* Visita ripetuta nella sessione: tg-upgrades.js ha già rimosso il
       nodo grazie alla classe .tg-noloader. Niente attesa. */
    if(!el){ injectTheme(); return; }

    var gone=false;
    function exit(){
      if(gone)return; gone=true;
      el.style.transition='opacity .45s cubic-bezier(.16,1,.3,1)';
      el.style.opacity='0';
      el.style.pointerEvents='none';
      injectTheme();
      setTimeout(function(){ if(el.parentNode)el.parentNode.removeChild(el); },500);
    }
    setTimeout(exit,1100);
    /* chi tocca, scorre o preme un tasto ha già deciso: salta la sequenza */
    ['pointerdown','keydown','wheel','touchstart'].forEach(function(ev){
      window.addEventListener(ev,exit,{once:true,passive:true});
    });
    /* failsafe: qualunque cosa vada storta, a 3s il sito c'è comunque */
    setTimeout(function(){ injectTheme(); exit(); },3000);
  })();

  /* ---------- 2 · AGGIUNGI → CHECKOUT DIRETTO ---------- */
  /* Capture su document: precede il listener in bolla registrato da
     ajaxAtc() in tg-upgrades.js. stopImmediatePropagation lo disinnesca. */
  document.addEventListener('submit',function(e){
    var form=e.target;
    if(!form||!form.classList||!form.classList.contains('product__form'))return;

    e.preventDefault();
    e.stopImmediatePropagation();

    var btn=form.querySelector('[name="add"]');
    var prev=btn?btn.textContent:'';
    if(btn){btn.disabled=true;btn.textContent='···';}

    fetch(ROOT+'/cart/add.js',{
      method:'POST',body:new FormData(form),headers:{'Accept':'application/json'}
    })
    .then(function(r){ if(!r.ok)throw new Error('atc'); return r.json(); })
    .then(function(){ return fetch(ROOT+'/cart.js').then(function(r){return r.json();}); })
    .then(function(cart){
      var lines=(cart&&cart.items)?cart.items.length:1;
      /* Un'unica riga: non c'è nulla da comporre, si paga.
         Più righe (se un giorno il catalogo cresce): il carrello ha senso. */
      window.location.href = lines===1 ? (ROOT+'/checkout') : (CFG.cart||ROOT+'/cart');
    })
    .catch(function(){
      /* rete o endpoint KO: submit nativo, Shopify gestisce da sé */
      if(btn){btn.disabled=false;btn.textContent=prev;}
      HTMLFormElement.prototype.submit.call(form);
    });
  },true);
})();
